import React, { useEffect, useState } from "react";
import { 
    Grid,
    TextField,
    MenuItem,
    FormControl
} from '@mui/material';
import muiInputStyles from "../../../../uiComponents/MuiInput/MuiInputStyles";

import './index.css';

export default function FinalConsensus(props) {
    const classes = muiInputStyles();

    var defaultClassification = props.finalClassification;
    var defaultComment = props.finalComments;
   
    const [classification, setClassification] = useState(defaultClassification);
    const [comment, setComment] = useState(defaultComment);

    useEffect(() => { 
        setClassification(defaultClassification);
        setComment(defaultComment);
      }, [defaultClassification, defaultComment] );

    const handleClassificationChange = (event) => {
        let newClassification = event.target.value;
        setClassification(newClassification);
        props.handleConsensusClassificationChange(newClassification);
    }

    const handleCommentChange = (event) => {
        let newComment = event.target.value;
        setComment(newComment);
        props.handleConsensusCommentChange(newComment);
    }

    return(
        <section className="section">
            <h2 className="sectionHeading">Final Consensus</h2>
            <div className="sectionContent">
                <Grid container spacing={0} >
                    <Grid item md={3} sm={2} />
                    <Grid item md={6} sm={8} xs={12}>
                        <div className="classSelect">
                            <span className="requiredIndicator">*</span> Indicates a required field.
                        </div>
                        <div className="finalConsensusFormItem classSelect">
                            <FormControl fullWidth>
                                <TextField
                                    fullWidth
                                    size="small"
                                    id="finalClassificationSelect"
                                    className={classes.muiInputs}
                                    value={classification || ''}
                                    onChange={handleClassificationChange}
                                    variant="outlined"
                                    label="Classification"
                                    required
                                    role="combobox" // MUI role modification for aria-required and additional required elements
                                    aria-required="true"
                                    aria-controls="litCategory"
                                    aria-expanded="false"
                                    select
                                    SelectProps={{ 
                                        MenuProps: { 
                                          disablePortal: true, // makes the popover render inside the normal React tree (instead of attaching it to the body)
                                        }, 
                                    }}
                                >
                                    <MenuItem value="Benign">Benign</MenuItem>
                                    <MenuItem value="Likely Benign">Likely Benign</MenuItem>
                                    <MenuItem value="Uncertain Significance">Uncertain Significance</MenuItem>
                                    <MenuItem value="Likely Pathogenic">Likely Pathogenic</MenuItem>
                                    <MenuItem value="Pathogenic">Pathogenic</MenuItem>
                                </TextField>
                            </FormControl>
                        </div>
                        <div className="finalConsensusFormItem">
                            <FormControl fullWidth>
                                <TextField
                                fullWidth
                                size="small"
                                name="comment"
                                id="comments"
                                className={classes.muiInputs}
                                value={comment || ''}
                                onChange={handleCommentChange}
                                variant="outlined"
                                label="Comments"
                                inputProps={{ 
                                    maxLength: 1000,
                                    "aria-required": true, // required attr for screen readers
                                }}
                                multiline
                                minRows={6}
                                required
                                />
                            </FormControl>
                        </div>
                    </Grid>
                    <Grid item md={3} sm={2} />
                </Grid>
            </div>
        </section>
    )
}

